import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from './modules/reducer';
import {
    persistAnalysisFiltersMiddleware,
    readPersistedAnalysisDateUi,
    setAnalysisDatePreset,
} from './modules/analysisFilters';
import { persistExploitationDateUiMiddleware } from './modules/exploitationDateUi';
import { persistFiltersExpandedUiMiddleware } from './modules/filtersExpandedUi';
import { persistStatsVenueMiddleware } from './modules/stats';
import { persistListTablesSortMiddleware } from './modules/tables';
import { LOADING_SETTING_SUCCESS } from './modules/settings';
import Utils from '../services/Utils';

/** Cinema + recreation-center (not cinema-festival): no saved analyses/stats prefs → default « today » instead of last 30 days. */
function analysisFiltersCinemaDefaultMiddleware({ dispatch, getState }) {
    return (next) => (action) => {
        const staleSettingSuccess =
            action.type === LOADING_SETTING_SUCCESS
            && getState().settings?.loadingRequestId !== action.requestId;
        const result = next(action);
        if (action.type !== LOADING_SETTING_SUCCESS || staleSettingSuccess) {
            return result;
        }
        if (readPersistedAnalysisDateUi()) {
            return result;
        }
        const t = action.setting?.customer?.type;
        if (Utils.customerTypeStatsDefaultsToToday(t)) {
            dispatch(setAnalysisDatePreset('today'));
        }
        return result;
    };
}

const store = createStore(
    reducer,
    applyMiddleware(
        thunk,
        analysisFiltersCinemaDefaultMiddleware,
        persistAnalysisFiltersMiddleware,
        persistStatsVenueMiddleware,
        persistExploitationDateUiMiddleware,
        persistFiltersExpandedUiMiddleware,
        persistListTablesSortMiddleware
    )
);

export default store;
export * from './modules';
